import './CardStar.css'

function CardStar({text="texto"}) {
  return (
    <div className="content-card-start">

    <div className="Card-div-landing-escuchaescucha"><h2>{text}</h2></div>
  </div>
  
  );
}

export default CardStar;
